import { useMemo } from "react";

import { useQuery } from "@tanstack/react-query";

import GeographyApiService from "../services/GeographyApiService";
import type { IWebAnalysisGeoRequestParams } from "../types/GeoDataTypes";
import { transformRegionalData } from "../utils/geoDataUtils";

export const useGeographyData = (apiParams: IWebAnalysisGeoRequestParams, isRegionalEnabled: boolean) => {
    const { geographyApiService } = useMemo(
        () => ({
            geographyApiService: new GeographyApiService(),
        }),
        [],
    );
    return useQuery({
        queryKey: ["geographyTableData", apiParams, isRegionalEnabled],
        queryFn: () => {
            const {
                from,
                to,
                timeGranularity = "Monthly",
                webSource = "Desktop",
                includeSubDomains,
                isWindow,
                orderBy,
                country,
                key,
            } = apiParams;

            // Call the API and transform the data within the query function
            return geographyApiService
                .getDomainsGeographyTableData({
                    from,
                    to,
                    timeGranularity,
                    webSource,
                    includeSubDomains,
                    isWindow,
                    orderBy,
                    country,
                    key,
                    includeRegionalDomains: isRegionalEnabled,
                })
                .then((data) => {
                    if (!isRegionalEnabled) {
                        return data;
                    }
                    return transformRegionalData(data);
                });
        },
    });
};
